document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.fit-logo-container');

  sections.forEach(section => {
    const scrollArea = section.querySelector('.scroll-area');
    const container = section.querySelector('.wheel-logo');
    const leftBtn = section.querySelector('.scroll-btn.left');
    const rightBtn = section.querySelector('.scroll-btn.right');

    if (!scrollArea || !container) return;

    const items = Array.from(container.querySelectorAll('.cover-item'));
    if (!items.length) return;

    const gap = parseInt(getComputedStyle(container).gap) || 0;

    // --------------------
    // Hide arrows on mobile or if 1 product
    // --------------------
    function updateArrowVisibility() {
      const isMobile = window.innerWidth <= 768;
      const singleProduct = items.length <= 1;

      if (leftBtn) leftBtn.style.display = (isMobile || singleProduct) ? 'none' : '';
      if (rightBtn) rightBtn.style.display = (isMobile || singleProduct) ? 'none' : '';
    }

    updateArrowVisibility();
    window.addEventListener('resize', updateArrowVisibility);

    // --------------------
    // Scroll buttons functionality
    // --------------------
    function scrollByOne() {
      const firstItem = items[0];
      if (!firstItem) return;
      const width = firstItem.offsetWidth + gap;
      return width;
    }

    leftBtn?.addEventListener('click', () => {
      scrollArea.scrollBy({ left: -scrollByOne(), behavior: 'smooth' });
    });
    rightBtn?.addEventListener('click', () => {
      scrollArea.scrollBy({ left: scrollByOne(), behavior: 'smooth' });
    });

    // Update arrow disabled state
    function updateArrows() {
      if (!leftBtn || !rightBtn) return;
      leftBtn.classList.toggle('disabled', scrollArea.scrollLeft <= 0);
      rightBtn.classList.toggle(
        'disabled',
        scrollArea.scrollLeft + scrollArea.clientWidth >= scrollArea.scrollWidth - 1
      );
    }

    scrollArea.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });
});
